// Renders an order item's customizationDetails (JSON string of [{name, value}]) — currently
// populated from Shopify line item properties, e.g. the actual flavor mix of a "Custom 5-Pack"
// bundle, so staff can see it without opening Shopify. Renders nothing if there's none.
import React from 'react';

export default function CustomizationDetails({ item }) {
  if (!item?.customizationDetails) return null;
  let entries = [];
  try {
    entries = JSON.parse(item.customizationDetails);
  } catch {
    return null;
  }
  if (!Array.isArray(entries) || entries.length === 0) return null;

  return (
    <div className="small text-muted ms-2" style={{ fontSize: 11 }}>
      {entries.map((e, i) => (
        <div key={i}>
          {e.name}: <span className="fw-semibold">{e.value}</span>
        </div>
      ))}
    </div>
  );
}
